// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RjsAI","content":"styles_content__FOfPT","tableWrap":"styles_tableWrap__Y1oD1"};